<template>
  <div>
    <BallNumbers
      :numbers="numbersPowerBallSet"
      @handleChosenItem="handleChosenNumber"
      @handleAddLine="$emit('handleAddLine')"
    />
  </div>
</template>

<script>
import BallNumbers from '@/components/common/ball/ball-numbers.vue';
export default {
  props: {
    numbersPowerBallSet: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BallNumbers
  },
  methods: {
    handleChosenNumber(index) {
      this.$emit('handleChosenItem', {index, type: 'power'})
    }
  }
}
</script>

<style scoped>

</style>
